const PINCODE_REGEX = {
  IN: /^\d{6}$/, // India
  KE: /^\d{5}$/, // Kenya
  MY: /^\d{5}$/, // Malaysia
};

export const validatePincode = (pin, countryCode = process.env.REACT_APP_COUNTRY_CODE) => {
  return PINCODE_REGEX[countryCode]?.test(pin) ?? false;
};